import contentfulLanguages from '@/locales.json';

const chinaOverride = process.env.NEXT_PUBLIC_CHINA_OVERRIDE === 'true';
const defaultLocale = contentfulLanguages?.items.find((locale) => locale.default)?.code || '';

export const config = {
    language: chinaOverride
        ? { default: 'cn', supported: contentfulLanguages?.items.map((locale) => locale.code) }
        : {
              default: process.env.NEXT_PUBLIC_DEFAULT_LANGUAGE || defaultLocale,
              supported: contentfulLanguages?.items.map((locale) => locale.code),
          },
    supertokens: {
        hubUrl: `${process.env.NEXT_PUBLIC_SITE_URL}/${defaultLocale}/${process.env.NEXT_PUBLIC_SUPERTOKEN_HUB}`,
        apiBasePath: process.env.NEXT_PUBLIC_SUPERTOKEN_CONFIG_API_BASE_PATH,
        websiteDomain: `/${defaultLocale}/${process.env.NEXT_PUBLIC_SUPERTOKEN_HUB}/${process.env.NEXT_PUBLIC_SUPERTOKEN_WEB_PATH}`,
    },
};
